var map = {
	"./slideshow_a.png": 59437,
	"./slideshow_b.jpg": 7597,
	"./slideshow_c.jpg": 64522,
	"./slideshow_d.png": 67668,
	"./slideshow_e.jpg": 53510,
	"./slideshow_f.jpg": 2747,
	"./slideshow_g.jpg": 5371,
	"./slideshow_h.jpg": 39102,
	"./slideshow_i.png": 56603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6617;